import React from 'react';

import type { FeatureContentItem } from './index';
import { parseJson } from '@/utils/parseJson';
import { twMerge } from '@weee-fe/module';
interface DescriptionProps {
  item: FeatureContentItem;
  className?: string;
}

const Description: React.FC<DescriptionProps> = ({ className, item }) => {
  const { description, description_style } = item;
  const descriptionStyle = parseJson(description_style) ?? {};

  if (!description) return <></>;
  return (
    <div
      data-role="description"
      className={twMerge('enki-body-xs text-surface-100-fg-minor break-words', className)}
      style={{
        color: descriptionStyle.color,
        textAlign: descriptionStyle.align
      }}
      dangerouslySetInnerHTML={{ __html: description }}></div>
  );
};

export default Description;
